import type { MiniRatingSummaryProps } from './MiniRatingSummary.typed';
import * as Styled from './MiniRatingSummary.styled';
import { RatingAverage } from '../RatingAverage/RatingAverage';
import { useTheme } from 'styled-components';

const MiniRatingSummary = (props: MiniRatingSummaryProps) => {
  const {
    onClickRatings,
    onClickReviews,
    average,
    reviewCount,
    leadingIcon,
    trailingIcon,
  } = props;
  const theme = useTheme();
  const hasRating = Boolean(average && reviewCount);

  return (
    <Styled.Rating>
      {hasRating ? (
        <Styled.RatingLinkButton
          onClick={onClickRatings}
          forwardedAs={onClickRatings ? 'button' : 'div'}
          fontSize="M16"
        >
          {leadingIcon}
          <RatingAverage average={average} reviewCount={reviewCount} />
          {trailingIcon}
        </Styled.RatingLinkButton>
      ) : (
        <>
          <Styled.StarIcon
            height={16}
            width={16}
            color={theme.colors.GREY_DARK}
          />
          <Styled.NoRatingLinkButton
            ofType="TERTIARY"
            fontSize="M16"
            onClick={onClickReviews}
          >
            No rating
          </Styled.NoRatingLinkButton>
        </>
      )}
    </Styled.Rating>
  );
};

export { MiniRatingSummary };
